export interface EIP6963ProviderInfo {
  rdns: string
  name?: string
  icon?: string
  uuid?: string
}

export interface EIP6963ProviderDetail {
  info: EIP6963ProviderInfo
  provider: unknown
}

type Subscriber = (providers: EIP6963ProviderDetail[]) => void

export interface Store {
  getProviders(): EIP6963ProviderDetail[]
  subscribe(callback: Subscriber): () => void
}

/**
 * Minimal stub that emulates the mipd store API used by wagmi/AppKit.
 * It avoids pulling in the real mipd dependency (which is not available in this environment)
 * while still letting the consumer safely enumerate injected providers.
 */
export function createStore(initialProviders: EIP6963ProviderDetail[] = []): Store {
  let providers = [...initialProviders]
  const subscribers = new Set<Subscriber>()

  const notify = () => {
    const snapshot = providers.map(provider => ({ ...provider }))
    subscribers.forEach(callback => {
      try {
        callback(snapshot)
      } catch (error) {
        console.warn('[mipd stub] subscriber callback failed', error)
      }
    })
  }

  return {
    getProviders() {
      return providers.map(provider => ({ ...provider }))
    },
    subscribe(callback: Subscriber) {
      subscribers.add(callback)
      callback(providers.map(provider => ({ ...provider })))
      return () => {
        subscribers.delete(callback)
      }
    }
  }
}

export default { createStore }
